module.exports = __webpack_public_path__ + "img/图片11.26a03630.png";